var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./PerspectiveArchivesList.jinja');
require('./PerspectiveArchivesList.less');

var PerspectiveArchivesListInner = require('front/components/PerspectiveArchivesList/PerspectiveArchivesListInner');
var PerspectiveArchivesListInnerTemplate = require('front/components/PerspectiveArchivesList/PerspectiveArchivesListInner.jinja');

var objectFitImages = require('object-fit-images');

module.exports = Base.extend({

    template: template,

    events: {
        'click .PerspectiveArchivesList-btnMore': 'onClickMoreButton'
    },

    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'PerspectiveArchivesListInner': {selector: '.PerspectiveArchivesListInner', viewConstructor: PerspectiveArchivesListInner}
    },

    moreApi: function () {
        return this.state.next;
    },

    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'moreApi');

        this.state = {
            next: Urls['front:api:perspective-issue']() + '?offset=' + this.$('.PerspectiveArchivesListInner-archive').size(),
            hasMore: false
        };

        Base.prototype.initialize.call(this, options);
    },

    onClickMoreButton: function () {
        var self = this;
        this.$('.PerspectiveArchivesList-btnMore').addClass('Button--loading');

        this.forceLoadData(this.moreApi)
            .then(function () {
                self.state.next = self.data.next;
                var $archives = $(PerspectiveArchivesListInnerTemplate.render({data: self.data.results}));
                self.state.hasMore = !!self.data.next;

                self.$('.PerspectiveArchivesList-btnMore')
                    .toggle(!!self.state.hasMore)
                    .removeClass('Button--loading');

                self.$('.PerspectiveArchivesList-archives').append($archives);

                app.animateShowMoreSlideDown({$items: $archives});

                $(window).resize();

                new PerspectiveArchivesListInner({
                    el: $archives[0]
                });

                window.app.utils.updateLinksAttributes(self.$('.PerspectiveArchivesList-archives'));

                objectFitImages();
            });
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/PerspectiveArchivesList/PerspectiveArchivesList.js
// module id = 226
// module chunks = 0